import taxStatus from '@/languages/ko-kr/tax-status'

export default {
  'keep-kr': '@:terms.keep-kr',
  'tax-bill': '@:terms.tax@:terms.bill',
  'payment': '@:terms.payment',
  'taxes': '@:terms.tax',
  'count': '@:terms.count',
  'KRW': '@:terms.currency',
  'unpaid': '미납',
  'total': '@:terms.total',
  'total-unpaid': '@:terms.total @:pages.taxes.unpaid 건수',
  'total-unpaid-amount': '@:terms.total @:pages.taxes.unpaid @:terms.amount',
  'certificate-register': '@:terms.register하기',
  'payment-register': '@:terms.payment하기',
  'message': {
    'title': ['대표님! 국세, 지방세', '놓치지 마세요!'],
    'empty-histories': ['납부내역이 없습니다.'],
    'processing-cert-message': '@:terms.certificate를 @:terms.register중입니다. @:terms.register이' +
      '완료되면 카톡으로 알려드립니다.',
    'empty-tax': '세금 고지서가 존재하지 않습니다.',
    'empty-taxes': ['세금이 조회되면,', '카톡으로 알람을 보내드립니다.'],
    'none-cert': ['공동인증서가', '등록되지 않았습니다.'],
    'processing-cert': ['공동인증서를 등록 중입니다.'],
  },
  'processing-cert-message': '@:terms.certificate를 @:terms.register중입니다. @:terms.register이' +
    '완료되면 카톡으로 알려드립니다.',
  'none-cert-message': '@:terms.certificate를 @:terms.register해주시면 @:terms.bill가 조회됩니다.',
  'empty-message': ['@:terms.bill가 조회되면,', '카톡으로 알람을 보내드립니다.'],
  'error': {
    'need-pay': '@:pages.taxes.unpaid 목록을 불러오는데 실패하였습니다.',
    'already-paid': '@:pages.taxes.payment-histories을 불러오는데 실패하였습니다.',
    'update-tax-status': '@:terms.tax @:terms.status를 @:terms.change하는데 실패하였습니다.',
  },
  'due-date-diff': {
    'over': '경과',
    'left': '남음',
    'today': '오늘까지',
  },
  'date': '{date}일',
  ...taxStatus,
  'confirm': {
    'confirmed-expired': {
      'title': '공동인증서가 만료되었습니다.',
      'description': '재등록 후 납부하실 수 있습니다.',
    },
    'confirmed-tax': {
      'title': '담당 세무사가 있으신 경우',
      'description': '최종 신고 건인지 담당 세무사에게 확인 후 납부해주시기 바랍니다.',
    },
    'unknown': {
      'title': '납부 불가한 고지서입니다',
      'description': '자세한 사항은 문의하기를 눌러 확인해주세요.',
    },
    'already-paid': {
      'title': '납부 불가한 고지서입니다',
      'description': '이미 납부하신 고지서가 조회되었습니다. 자세한 사항은 문의하기를 눌러 확인해주세요.',
    },
  },
  'dialog': {
    'footer': {
      'confirm': '확인',
      'cancel': '취소',
      're-register': '재등록하기',
      'inquire': '문의하기',
      'close': '닫기',
    },
  },
  'title-invalid': '@:pages.tax.title-invalid',
  'indefinite': '@:terms.indefinite',
  'need-pay': '@:terms.payment @:terms.need',
  'already-paid': '@:terms.payment @:terms.complete',

  // ======================================= tax-already-paid
  'payment-histories': '@:terms.payment내역',
  'due-date': '기한',
  'over': '경과',
  'transfer-date': '@:pages.taxes.completed일',
  'cancel': '@:terms.cancel',
  'cancel-select': '선택 @:terms.cancel',
  'footer': {
    'payment-register': '@:terms.payment하기',
    'plz-select': '@:terms.payment할 @:terms.tax를 선택해주세요.',
    'register-cert': '@:terms.certificate 등록하기',
  },
}
